import React from 'react';
import _ from 'lodash';
import { ResponsiveBarCanvas } from '@nivo/bar';
import { ChartProp } from '../../enum/apiResultProp/ChartProp';
import { Segment } from 'semantic-ui-react';

export default ({ chartProps }) => {
    const data = chartProps[ChartProp.Data];
    const comparisonValues = chartProps[ChartProp.ComparisonValues];
    const groupBy = chartProps[ChartProp.GroupBy];
    const groupMode = chartProps[ChartProp.GroupMode];
    const layout = chartProps[ChartProp.Layout];
    const enableTotals = chartProps[ChartProp.EnableTotals];
    const hasLegend = chartProps[ChartProp.HasLegend];
    const bottomAxisLabel = chartProps[ChartProp.BottomAxisLabel];
    const leftAxisLabel = chartProps[ChartProp.LeftAxisLabel];
    const enableLabel = chartProps[ChartProp.EnableBarLabel];

    let barChartProps = {
        data: data,
        keys: comparisonValues,
        indexBy: groupBy,
        groupMode: groupMode,
        layout: layout,
        enableTotals: enableTotals,
        enableLabel: enableLabel
    };

    const colorSet = [
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
        '#ff1493', '#20b2aa', '#f39c12', '#e74c3c', '#3498db', '#2ecc71', '#9b59b6', '#16a085', '#f1c40f', '#8e44ad'
    ];

    let legends = [];
    let margin = { top: 50, right: 50, bottom: 50, left: 50 };
    if (hasLegend) {
        margin = { top: 50, right: 150, bottom: 50, left: 50 };
        legends = [
            {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 25,
                translateY: 0,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 0,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 15,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]
    }

    // const customTooltip = ({ point }) => (
    //     <Segment>
    //         <div
    //             style={{
    //                 width: "12px",
    //                 height: "12px",
    //                 marginRight: "8px",
    //                 display: "inline-block",
    //                 backgroundColor: point.serieColor,
    //             }}
    //         />
    //         {point.data.customXLabel}
    //         {point.data.customYLabel}
    //     </Segment>
    // );

    if (bottomAxisLabel) {
        barChartProps = { ...barChartProps, axisBottom: { legend: bottomAxisLabel, legendOffset: 40, legendPosition: 'middle' } };
    }

    if (leftAxisLabel) {
        barChartProps = { ...barChartProps, axisLeft: { legend: leftAxisLabel, legendOffset: -40, legendPosition: 'middle' } };
    }

    return (
        <div style={{ height: 500 }}>
            <ResponsiveBarCanvas
                {...barChartProps}

                labelPosition='end'
                labelOffset={10}

                colors={colorSet}

                // tooltip={customTooltip}

                margin={margin}

                legends={legends}
            />
        </div>
    );
}